import { EncabezadoTabla } from './EncabezadoTabla.js';
import { FilasTabla } from './FilasTabla.js';
import { LoaderTabla } from './LoaderTabla.js';
export const TablaN = ({ elementos, id, itemsEncabezado, itemsFilas, elemNoEncontrado, ocultarEncabezadoMobile, classNameTabla, mostrarElem, mostrarLoader, classNameFilas }) => {
 
    return (
        <>
            <div className={'container-fluid bg-white rounded-4 textoTablas tabla overflow-x-hidden position-relative mx-0 mx-sm-auto ' + classNameTabla} id={id} >
                <EncabezadoTabla ocultarEncabezadoMobile={ocultarEncabezadoMobile} itemsEncabezado={itemsEncabezado} />
                {mostrarLoader ?
                    <LoaderTabla />
                    :
                    <FilasTabla mostrarElem={mostrarElem} elementos={elementos} elemNoEncontrado={elemNoEncontrado}
                        itemsFilas={itemsFilas} ocultarEncabezadoMobile={ocultarEncabezadoMobile} classNameFilas={classNameFilas}/>
                }
            </div> 
        </>
    );
}
